import {createTypes, async} from 'redux-action-creator'

export default {
  ...createTypes([
    ...async('VERIFY_ACCEPTANCE'),
    ...async('ACCEPT_PRIVACY')
    ],
  'TERMS/',
  ),
  ACCEPT_TC: 'TERMS/ACCEPT_T&C',
  ENABLE_ACCEPT_BUTTON: 'TERMS/ENABLE_ACCEPT_BUTTON'
}



// WEBPACK FOOTER //
// ./src/sections/terms/types/terms.js